var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _mask, _path, _path2, _path3, _rect9, _rect10, _path4, _circle, _circle2, _circle3, _path5, _rect11, _rect12, _rect13, _rect14, _rect15, _ellipse, _path6, _path7, _path8, _path9, _path10, _ellipse2, _ellipse3, _ellipse4, _path11, _path12, _path13, _path14, _path15, _path16, _path17;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCompanies(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 732,
    height: 481,
    viewBox: "0 0 732 481",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 34.7343,
    y: 39.5809,
    width: 65.4298,
    height: 8.88553,
    rx: 4.44276,
    fill: "#B0BEC5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 25.041,
    y: 62.1987,
    width: 75.1231,
    height: 8.07775,
    rx: 4.03888,
    fill: "#B0BEC5"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 49.2743,
    y: 84.0087,
    width: 75.9309,
    height: 8.88553,
    rx: 4.44276,
    fill: "#B0BEC5"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    y: 62.1987,
    width: 18.5788,
    height: 8.07775,
    rx: 4.03888,
    fill: "#B0BEC5"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 21.8099,
    y: 84.0087,
    width: 22.6177,
    height: 8.88553,
    rx: 4.44276,
    fill: "#B0BEC5"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 7.26999,
    y: 84.0087,
    width: 9.6933,
    height: 8.88553,
    rx: 4.44276,
    fill: "#B0BEC5"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 18.5788,
    y: 39.5809,
    width: 9.6933,
    height: 8.88553,
    rx: 4.44276,
    fill: "#B0BEC5"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 88.1242,
    y: 8.96216,
    width: 126.667,
    height: 96.7797,
    rx: 17.5,
    fill: "#EA80FC",
    stroke: "#263238",
    strokeWidth: 5
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-9-inside-1_412_7581",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M145.399 57.3237C149.285 58.8962 153.631 58.8962 157.517 57.3237L207.779 36.988C224.235 30.3297 219.472 5.85632 201.719 5.85632H101.196C83.4441 5.85632 78.6808 30.3297 95.1372 36.988L145.399 57.3237Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M145.399 57.3237C149.285 58.8962 153.631 58.8962 157.517 57.3237L207.779 36.988C224.235 30.3297 219.472 5.85632 201.719 5.85632H101.196C83.4441 5.85632 78.6808 30.3297 95.1372 36.988L145.399 57.3237Z",
    fill: "#EA80FC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M95.1372 36.988L97.0125 32.353L95.1372 36.988ZM207.779 36.988L205.903 32.353L207.779 36.988ZM157.517 57.3237L155.642 52.6887L157.517 57.3237ZM145.399 57.3237L147.274 52.6887L145.399 57.3237ZM159.393 61.9587L209.654 41.623L205.903 32.353L155.642 52.6887L159.393 61.9587ZM201.719 0.856323H101.196V10.8563H201.719V0.856323ZM93.2618 41.623L143.523 61.9587L147.274 52.6887L97.0125 32.353L93.2618 41.623ZM101.196 0.856323C77.9499 0.856323 71.7124 32.9041 93.2618 41.623L97.0125 32.353C85.6492 27.7554 88.9384 10.8563 101.196 10.8563V0.856323ZM209.654 41.623C231.203 32.9041 224.966 0.856323 201.719 0.856323V10.8563C213.977 10.8563 217.267 27.7554 205.903 32.353L209.654 41.623ZM155.642 52.6887C152.958 53.7745 149.958 53.7745 147.274 52.6887L143.523 61.9587C148.613 64.0179 154.303 64.0179 159.393 61.9587L155.642 52.6887Z",
    fill: "#263238",
    mask: "url(#path-9-inside-1_412_7581)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M233.37 18.9827C233.37 28.1894 226.251 35.4654 217.695 35.4654C209.14 35.4654 202.021 28.1894 202.021 18.9827C202.021 9.776 209.14 2.5 217.695 2.5C226.251 2.5 233.37 9.776 233.37 18.9827Z",
    fill: "#FF1744",
    stroke: "white",
    strokeWidth: 5
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 154.362,
    y: 80.6846,
    width: 506.861,
    height: 363.359,
    rx: 17.5,
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 5
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 165.421,
    y: 65.7551,
    width: 511.861,
    height: 368.359,
    rx: 20,
    fill: "#EEFF41"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M323.372 220.556C323.372 249.205 300.893 272.293 273.33 272.293C245.767 272.293 223.288 249.205 223.288 220.556C223.288 191.907 245.767 168.819 273.33 168.819C300.893 168.819 323.372 191.907 323.372 220.556Z",
    fill: "#EA80FC",
    stroke: "#263238",
    strokeWidth: 5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 201.5,
    cy: 94.5,
    r: 9,
    fill: "#FF1744",
    stroke: "#263238",
    strokeWidth: 5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 244.5,
    cy: 94.5,
    r: 9,
    fill: "#C4C4C4",
    stroke: "#263238",
    strokeWidth: 5
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 286.5,
    cy: 94.5,
    r: 9,
    fill: "#FFCCBC",
    stroke: "#263238",
    strokeWidth: 5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M165 121L676 121",
    stroke: "#263238",
    strokeWidth: 5,
    strokeLinecap: "square"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 385.759,
    y: 166.319,
    width: 247.456,
    height: 4.51975,
    rx: 2.25987,
    fill: "#263238"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 385.759,
    y: 188.918,
    width: 247.456,
    height: 4.51975,
    rx: 2.25987,
    fill: "#263238"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 385.759,
    y: 248.805,
    width: 247.456,
    height: 4.51975,
    rx: 2.25987,
    fill: "#263238"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 385.759,
    y: 271.404,
    width: 247.456,
    height: 4.51975,
    rx: 2.25987,
    fill: "#263238"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 388.259,
    y: 337.18,
    width: 242.456,
    height: 50.3669,
    rx: 25.1834,
    fill: "white",
    stroke: "#263238",
    strokeWidth: 5
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 281.805,
    cy: 216.602,
    rx: 33.8981,
    ry: 36.7229,
    fill: "#FFCCBC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M321.918 227.901C321.918 233.829 314.11 238.07 310.053 238.07C305.997 238.07 308.923 233.829 308.923 227.901C308.923 221.972 311.082 218.862 315.138 218.862C319.194 218.862 321.918 221.972 321.918 227.901Z",
    fill: "#FFCCBC"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M275.59 243.155L303.839 236.376L313.5 252L302.144 264.624L286.325 271.404L275.59 243.155Z",
    fill: "#FFCCBC"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M253.353 197.663L251.278 196.268L251.171 196.427L251.09 196.6L253.353 197.663ZM296.556 250.585C297.701 249.814 298.006 248.261 297.235 247.115C296.465 245.969 294.911 245.665 293.765 246.436L296.556 250.585ZM313.208 218.701C313.119 220.079 314.164 221.268 315.542 221.357C316.92 221.445 318.109 220.401 318.198 219.023L313.208 218.701ZM283.528 253.448C282.973 252.184 281.498 251.61 280.234 252.165C278.97 252.721 278.396 254.196 278.951 255.46L283.528 253.448ZM285.527 270.422C286.083 271.686 287.558 272.26 288.822 271.704C290.086 271.149 290.66 269.674 290.105 268.41L285.527 270.422ZM316.106 217.273C314.766 216.938 313.409 217.753 313.074 219.092C312.739 220.432 313.554 221.789 314.893 222.124L316.106 217.273ZM310.98 237.778V235.278H310.087L309.397 235.843L310.98 237.778ZM303.182 240.927C302.113 241.802 301.956 243.377 302.83 244.445C303.704 245.514 305.279 245.671 306.348 244.797L303.182 240.927ZM308.582 240.976C307.853 239.804 306.311 239.445 305.139 240.175C303.967 240.905 303.608 242.446 304.338 243.618L308.582 240.976ZM312.5 252L314.217 253.817L315.702 252.413L314.622 250.679L312.5 252ZM287.105 267.382C285.82 267.887 285.188 269.338 285.693 270.623C286.198 271.908 287.649 272.541 288.934 272.036L287.105 267.382ZM251.09 196.6C241.129 217.81 245.258 235.947 255.805 246.545C266.277 257.067 282.843 259.807 296.556 250.585L293.765 246.436C282.179 254.228 268.251 251.963 259.349 243.018C250.522 234.148 246.397 218.354 255.616 198.726L251.09 196.6ZM255.428 199.057C266.407 182.723 281.339 179.772 293.127 184.523C305.08 189.34 314.27 202.242 313.208 218.701L318.198 219.023C319.396 200.455 308.992 185.526 294.996 179.885C280.835 174.178 263.462 178.141 251.278 196.268L255.428 199.057ZM278.951 255.46L285.527 270.422L290.105 268.41L283.528 253.448L278.951 255.46ZM314.893 222.124C317.141 222.686 318.399 223.789 319.052 224.945C319.725 226.136 319.897 227.632 319.503 229.181C318.716 232.275 315.732 235.278 310.98 235.278V240.278C318.091 240.278 323.017 235.653 324.349 230.413C325.014 227.796 324.798 224.949 323.405 222.485C321.993 219.986 319.508 218.124 316.106 217.273L314.893 222.124ZM309.397 235.843L303.182 240.927L306.348 244.797L312.563 239.712L309.397 235.843ZM304.338 243.618L310.378 253.321L314.622 250.679L308.582 240.976L304.338 243.618ZM310.783 250.183C301.711 258.757 297.812 263.174 287.105 267.382L288.934 272.036C300.699 267.411 305.289 262.255 314.217 253.817L310.783 250.183Z",
    fill: "#263238"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M304.91 194.08C304.91 202.579 288.708 191.89 274.056 191.89C259.403 191.89 253.002 200.675 253.002 200.675C253.002 192.176 267.187 180.34 281.84 180.34C296.492 180.34 304.91 185.581 304.91 194.08Z",
    fill: "#263238"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M314.112 209.257C314.112 221.114 325.243 221.121 318.067 221.121C310.89 221.121 300.552 214.899 300.552 203.042C293.669 202.477 292.246 186.093 299.422 186.093C306.599 186.093 314.112 197.4 314.112 209.257Z",
    fill: "#263238"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 262.595,
    cy: 221.391,
    rx: 3.38981,
    ry: 3.95478,
    fill: "#263238"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 289.714,
    cy: 222.521,
    rx: 3.38981,
    ry: 3.95478,
    fill: "#263238"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 272.2,
    cy: 228.735,
    rx: 2.82484,
    ry: 3.38981,
    fill: "#263238"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M263.726 204.443C265.133 203.125 269.598 203.27 271.07 205.572M284.63 205.572C288.743 203.526 290.817 204.811 291.409 206.137",
    stroke: "#263238",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M275.025 242.295C279.41 241.916 281.274 240.692 283.5 236.645",
    stroke: "#263238",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M677 268V416C677 427.046 668.046 436 657 436H594",
    stroke: "#263238",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M663.962 95.3486C659.875 94.4691 661.793 67.8754 659.548 64.1972C657.303 60.519 641.026 56.0862 642.243 52.2157C643.461 48.3452 661.181 46.4201 664.734 43.9681C668.287 41.5161 677.024 25.5825 680.883 26.6972C684.743 27.8118 686.584 48.0577 689.017 51.5821C691.451 55.1065 707.385 61.9195 705.855 65.7809C704.324 69.6422 687.473 69.5695 683.831 71.8112C680.189 74.053 668.049 96.228 663.962 95.3486Z",
    fill: "#EA80FC"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M716.558 115.314C714.688 116.152 707.733 105.09 705.779 104.288C703.826 103.486 696.11 106.455 695.468 104.573C694.827 102.691 701.269 96.791 701.961 94.792C702.654 92.793 701.484 83.9644 703.332 83.2855C705.18 82.6066 711.779 90.0707 713.763 90.7572C715.746 91.4438 724.017 89.5139 724.532 91.4832C725.047 93.4525 718.369 98.3109 717.581 100.253C716.792 102.195 718.427 114.476 716.558 115.314Z",
    fill: "#FF1744"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M122.368 474.231C120.498 475.069 113.543 464.007 111.59 463.205C109.636 462.403 101.92 465.373 101.279 463.491C100.637 461.608 107.079 455.709 107.772 453.71C108.464 451.711 107.295 442.882 109.142 442.203C110.99 441.524 117.589 448.988 119.573 449.675C121.556 450.361 129.827 448.432 130.342 450.401C130.858 452.37 124.18 457.229 123.391 459.17C122.602 461.112 124.238 473.393 122.368 474.231Z",
    fill: "#FF1744"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M677.5 246.5V194.5",
    stroke: "#263238",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanies);
export default __webpack_public_path__ + "static/media/companies.f4c08ea15283e2a4ac135ae191a2bf6a.svg";
export { ForwardRef as ReactComponent };